import { parse } from 'qs'

export default (location) => parse(location, { ignoreQueryPrefix: true })
